module.exports = __webpack_public_path__ + "static/signup_done-df38a4b146947d110ba64b2ce7bb2634.svg";